import { render, staticRenderFns } from "./NotificationToast.vue?vue&type=template&id=3bb65b63&scoped=true"
import script from "./NotificationToast.vue?vue&type=script&lang=js"
export * from "./NotificationToast.vue?vue&type=script&lang=js"
import style0 from "./NotificationToast.vue?vue&type=style&index=0&id=3bb65b63&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb65b63",
  null
  
)

export default component.exports